import {
	CONFLUENCE_AIFC_DATABASE_CREATE_KEY,
	CONFLUENCE_AIFC_DATABASE_UPDATE_KEY,
} from '@atlassian/conversation-assistant-action-helpers/utils/confluence-actions';
import { getActionContentId } from '@atlassian/conversation-assistant-action-helpers/utils/get-action-data';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

/**
 * Actions whose content id is reported as `objectId` on message-level analytics events. Pages are
 * not listed because the editor plugin already reports `objectId` on its own `aiResult viewed`.
 */
const OBJECT_ID_ACTION_KEYS: ReadonlySet<string> = new Set([
	CONFLUENCE_AIFC_DATABASE_CREATE_KEY,
	CONFLUENCE_AIFC_DATABASE_UPDATE_KEY,
]);

/** Content id of the message's single object-id action; undefined when there is none or more than one. */
export const getMessageActionObjectId = (
	actions: readonly Pick<MessageAction, 'key' | 'data'>[] | undefined,
): string | undefined => {
	const objectActions = actions?.filter((action) => OBJECT_ID_ACTION_KEYS.has(action.key)) ?? [];
	if (objectActions.length !== 1) {
		return undefined;
	}
	return getActionContentId(objectActions[0]) || undefined;
};
